// 游戏常量定义
export const EMPTY = 0
export const BLACK = 1
export const WHITE = 2

// 棋盘方向：8个方向
export const DIRECTIONS = [
  [-1, -1], [-1, 0], [-1, 1],
  [0, -1],           [0, 1],
  [1, -1],  [1, 0],  [1, 1]
]

// 角落位置（权重最高）
export const CORNERS = [0, 7, 56, 63]

// 边缘位置（权重较高）
export const EDGES = [
  // 上边缘
  1, 2, 3, 4, 5, 6,
  // 下边缘
  57, 58, 59, 60, 61, 62,
  // 左边缘
  8, 16, 24, 32, 40, 48,
  // 右边缘
  15, 23, 31, 39, 47, 55
]

// 危险位置（角落相邻的位置）
export const DANGEROUS = [1, 8, 9, 6, 14, 15, 48, 49, 57, 54, 55, 62, 63]

// 棋盘大小
export const BOARD_SIZE = 8
export const CELL_COUNT = 64